import React, { Fragment } from 'react';
import { useHistory } from 'react-router-dom';
import dayjs from 'dayjs';
import PropTypes from 'prop-types';

import {
    Text,
    StyledCard,
    StyledCardContent,
    NoInformation,
    HorizontalRule,
    Progress,
    LoadMoreIcon,
    IconButton,
    FilledIconButton,
    DownloadIcon2,
} from '../../index';

const getType = (value) => {
    switch (value) {
        case 'one':
            return '1on1 Session';
        case 'group':
            return 'Group Session';
        case 'bonus':
            return 'Bonus';
        default:
            return 'Top Up';
    }
};

const CreditsList = ({ loading, data, type, onLoadMore, canLoadMore }) => {
    const history = useHistory();

    const handleOnClick = (id) => {
        history.push(`/provider/invoice/${id}`);
    };

    return (
        <StyledCard style={{ padding: '24px 40px 24px 35px' }}>
            <StyledCardContent
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    rowGap: '20px',
                    position: 'relative',
                }}
            >
                {loading && <Progress />}
                <Text $fontSize="18px" $bold>
                    {type === 'usage' ? 'Usage' : 'Reciept'}
                </Text>

                <div>
                    {data && data.length > 0 ? (
                        <Fragment>
                            {data.map((item) => (
                                <div
                                    style={{ display: 'grid', gridTemplateColumns: '1fr auto' }}
                                    key={item.id}
                                >
                                    <div
                                        style={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            rowGap: '5px',
                                        }}
                                    >
                                        <div
                                            style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'space-between',
                                                paddingRight: '10px',
                                            }}
                                        >
                                            <Text $color="gray2" $fontSize="12px">
                                                {dayjs(item.updatedAt).format('DD MMM YYYY')}
                                            </Text>
                                            <Text $color="gray2" $fontSize="12px">
                                                {getType(item.type)}
                                            </Text>
                                        </div>
                                        <div
                                            style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'space-between',
                                                paddingRight: '10px',
                                            }}
                                        >
                                            <Text>
                                                {type === 'usage'
                                                    ? item.staff?.user?.fullname
                                                    : item.type === 'topUp'
                                                    ? item.number
                                                    : 'Bonus'}
                                            </Text>
                                            <Text
                                                $color={
                                                    (type === 'usage' && item.type !== 'topUp') ||
                                                    ['REJECTED', 'CANCELLED'].includes(item.status)
                                                        ? 'pink'
                                                        : 'green'
                                                }
                                            >
                                                {type === 'usage' && item.type !== 'topUp'
                                                    ? '-'
                                                    : '+'}
                                                {item.amount} credits{' '}
                                                {item.status === 'REJECTED' && '[Rejected]'}
                                                {item.status === 'CANCELLED' && '[Cancelled]'}
                                            </Text>
                                        </div>
                                        {item.status === 'REJECTED' && (
                                            <div
                                                style={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'flex-start',
                                                    paddingRight: '10px',
                                                }}
                                            >
                                                <Text
                                                    $color="gray2"
                                                    $fontSize="12px"
                                                >{`Remark: ${item.remark}`}</Text>
                                            </div>
                                        )}
                                    </div>

                                    {type === 'reciept' && (
                                        <FilledIconButton
                                            style={{
                                                width: '28px',
                                                height: '28px',
                                                paddingBottom: '8px',
                                            }}
                                            onClick={() => handleOnClick(item.id)}
                                        >
                                            <DownloadIcon2 />
                                        </FilledIconButton>
                                    )}

                                    <HorizontalRule
                                        style={{
                                            gridColumnEnd: 'span 2',
                                            marginTop: '5px',
                                            marginBottom: '5px',
                                        }}
                                    />
                                </div>
                            ))}
                            <div
                                style={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                    marginTop: '20px',
                                }}
                            >
                                {canLoadMore && (
                                    <IconButton onClick={onLoadMore}>
                                        <LoadMoreIcon />
                                    </IconButton>
                                )}
                            </div>
                        </Fragment>
                    ) : (
                        <NoInformation />
                    )}
                </div>
            </StyledCardContent>
        </StyledCard>
    );
};

CreditsList.propTypes = {
    loading: PropTypes.bool,
    data: PropTypes.array,
    type: PropTypes.string,
    onLoadMore: PropTypes.func,
    canLoadMore: PropTypes.bool,
};

export default CreditsList;
